module.exports = __webpack_public_path__ + "media/application/images/icons/desktop-solid-white-1fda0f0be50fc1ef6b0c70afcc2ea391.svg";